import {
  INCREMENT_CART,
  DECREMENT_CART,
  SET_CART_COUNT,
  INCREMENT_UNPAID_CART,
  DECREMENT_UNPAID_CART,
  SET_UNPAID_CART_COUNT,
} from "../../Actions/cart";

const initialState = {
  count: Number(localStorage.getItem("total_count")) || 0,
  unpaidCount: Number(localStorage.getItem("unpaid_count")) || 0,
};

export default function cartReducer(state = initialState, action) {
  switch (action.type) {
    case INCREMENT_CART:
      const inc = state.count + 1;
      localStorage.setItem("total_count", inc);
      return { ...state, count: inc };
    case DECREMENT_CART:
      const dec = Math.max(0, state.count - 1);
      localStorage.setItem("total_count", dec);
      return { ...state, count: dec };
    case INCREMENT_UNPAID_CART:
      const incUnpaid = state.unpaidCount + 1;
      localStorage.setItem("unpaid_count", incUnpaid);
      return { ...state, unpaidCount: incUnpaid };
    case DECREMENT_UNPAID_CART:
      const decUnpaid = Math.max(0, state.unpaidCount - 1);
      localStorage.setItem("unpaid_count", decUnpaid);
      return { ...state, unpaidCount: decUnpaid };
    case SET_UNPAID_CART_COUNT:
      localStorage.setItem("unpaid_count", action.payload);
      return { ...state, unpaidCount: action.payload };
    case SET_CART_COUNT:
      localStorage.setItem("total_count", action.payload);
      return { ...state, count: action.payload };
    default:
      return state;
  }
}
